import React from 'react';
import { SidePanelProps } from './SidePanel.types';

type SidePanelContextProps = {
  closeButtonProps?: SidePanelProps['closeButtonProps'];
  helpButtonProps?: SidePanelProps['helpButtonProps'];
  skin?: SidePanelProps['skin'];
  isDraggable?: SidePanelProps['draggable'];
  backButtonProps?: SidePanelProps['backButtonProps'];
};

export const SidePanelContext = React.createContext(
  {} as SidePanelContextProps,
);
